<template>
    <div class="pane-content">
        <el-row type="flex" class="mt-2 mb-1">
            <h5 class="status-label">{{ moduleLabelWithCasting }} Property Mapping</h5>
        </el-row>
        <el-row class="mt-1">
            <span>{{ staticName }} can read from, write to, or stay in sync with {{ integrationNameWithCasing }}'s {{ moduleLabel }} properties. You can configure these settings below.</span>
        </el-row>
        <el-row class="mt-1">
            <span>
                <b>Best Practice</b>: {{ integrationNameWithCasing }} serves as the primary source of data, with {{ staticName }} reading the information.
            </span>
        </el-row>
        <el-row class="mb-2 mt-3">
            <div class="p-3 container">
                <span>
                    <b>Map {{ integrationNameWithCasing }} {{ moduleLabelWithCasting }} Properties to {{ staticName }}'s default and Custom Contact Fields</b>
                </span>
                <br/>
                <span class="mt-2">
                    <i class="fa fa-lock mr-2"></i>The {{ moduleLabel }} property mapping is disabled for modifications<br/>
                </span>
                <span>
                    <i class="fa fa-ban mr-2"></i>The {{ moduleLabel }} property is already selected and cannot be mapped multiple times<br/>
                </span>
                <span>
                    <i class="fa fa-trash mr-2"></i>Delete a {{ moduleLabel }} property mapping<br/>
                </span>
            </div>
        </el-row>
        <small v-if="model.settings.last_mapping_update && model.updated_by"
                class="block text-black-lt edited-by-text mt-2">
            <i>Last edited by: {{ getUser(model.updated_by).name }}, {{ model.settings.last_mapping_update | fixFullDateUTCRelative }}</i>
        </small>
        <div class="row form-group"
            v-if="!CRMModuleWasChanged">
            <div class="col-md-12 mt-3">
                <integration-property-mapper :integration="integrationName"
                                             :module="module"
                                             :custom-property-mappings="customPropertyMappings"
                                             :default-property-mappings="defaultPropertyMappings"/>
            </div>
        </div>
        <el-alert
            v-else
            class="mb-3"
            type="warning"
            :closable="false"
            show-icon>
            <div class="d-block">
                <div class="mb-2 text-black">
                    <template >
                        You’ve made important changes that need to be saved before you can modify the custom fields mapping.
                    </template>
                </div>
            </div>
        </el-alert>
    </div>
</template>

<script>
import IntegrationPropertyMapper from './hubspot/property-mapper.vue'
import { user_info_mixin } from '../../mixins'
import {mapGetters} from "vuex"
import {MODULE_CONTACT, MODULE_LEAD} from "../../../constants/integration_modules"
import _ from "lodash";

export default {
    components: {
        IntegrationPropertyMapper
    },
    mixins: [user_info_mixin],
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationName: {
            type: String,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        statics: {
            type: Object,
            required: false
        },
        module: {
          type: String,
          default: MODULE_CONTACT
        },
        defaultPropertyMappings: { type: Array, default: () => [] },
        customPropertyMappings: { type: Array, default: () => [] },
    },
    computed: {
        ...mapGetters(['CRMModuleWasChanged']),
        staticName() {
            return this.statics.name || 'Aloware'
        },
        moduleLabel () {
            switch (this.module) {
                case MODULE_LEAD:
                    return 'lead'
                default:
                    return 'contact'
            }
        },
        moduleLabelWithCasting () {
            return _.upperFirst(this.moduleLabel)
        }
    }
}
</script>
<style scoped>
.pane-content {
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
}

.section-header {
    margin: 0 12px 0 0;
    font-size: 20px;
}

.align-center {
    align-items: center;
}

.container {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 12px;
    font-size: 15px;
    line-height: 1.5;
    width: 100%;
    max-width: 100%;
}

.edited-by-text {
    text-align: right;
    font-size: 12px;
}
</style>
